import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';

import { HashRouter } from 'react-router-dom';

import { Provider } from 'react-redux';
import store from './Redux/store';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <HashRouter>
    <App />
    </HashRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);


